import React from 'react';

export const caseBlockCard = (mobile) => (
  <div>
    Para bloquear tu Tarjeta Ripley, ingresa a{' '}
    <a href={process.env.REACT_APP_URL_BANCO} target="_blank" rel="noreferrer">
      {mobile ? 'aquí' : 'www.bancoripley.com'}
    </a>{' '}
    e inicia sesión para ser atendido directamente por EVA o un ejecutivo;
    también puedes llamar al <strong>800 20 32 20</strong> o desde celular al{' '}
    <strong>227689200</strong>.
  </div>
);

export const caseChangeRipleyCard = (mobile) => (
  <div>
    Para realizar el cambio de tu Tarjeta Ripley, ingresa a{' '}
    <a href={process.env.REACT_APP_URL_BANCO} target="_blank" rel="noreferrer">
      {mobile ? 'aquí' : 'www.bancoripley.com'}
    </a>{' '}
    e inicia sesión para ser atendido directamente por EVA o un ejecutivo;
    también puedes llamar al <strong>800 20 32 20</strong> o desde celular al{' '}
    <strong>227689200</strong>.
  </div>
);

export const casePayAccount = (
  <div>
    Puedes pagar tu estado de cuenta{' '}
    <a
      href={process.env.REACT_APP_PE_URL_RIPLEY_CARD_PAYMENT}
      target="_blank"
      rel="noreferrer"
    >
      aquí
    </a>
    . También lo puedes hacer llamándonos al <strong> 800 20 32 20 </strong> o
    desde celular al <strong>227689200</strong>.
  </div>
);

export const caseRipleyPtosGo = (mobile) => (
  <div>
    Para información sobre tus Ripley Puntos Go, ingresa a{' '}
    <a href={process.env.REACT_APP_URL_BANCO} target="_blank" rel="noreferrer">
      {mobile ? 'aquí' : 'www.bancoripley.com'}
    </a>{' '}
    e inicia sesión para ser atendido directamente por EVA o un ejecutivo;
    también puedes llamar al <strong>800 20 32 20</strong> o desde celular al{' '}
    <strong>227689200</strong>.
  </div>
);

export const caseInsurancesRipley = (mobile) => (
  <div>
    Para información de un Seguro Ripley, ingresa a{' '}
    <a href={process.env.REACT_APP_URL_BANCO} target="_blank" rel="noreferrer">
      {mobile ? 'aquí' : 'www.bancoripley.com'}
    </a>{' '}
    e inicia sesión para ser atendido directamente por EVA o un ejecutivo;
    también puedes llamar al <strong>800 20 32 20</strong> o desde celular al{' '}
    <strong>227689200</strong>.
  </div>
);

export const caseExtendCompanyGiftCard = (
  <div>
    Para extender la vigencia de tu Gift Card Empresa, contacta a la persona o
    empresa que te entregó la tarjeta para que ellos gestionen directamente esta
    solicitud.
  </div>
);
